import { createSelector } from 'reselect';

export const layoutStateSelector = state => state.layout;

export const processingLoaderVisibilitySelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.showProcessingLoader
);

export const generatingLoaderVisibilitySelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.showGeneratingLoader
);

export const generatingLoaderProgressSelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.generatingLoaderProgress
);

export const starterLoaderVisibilitySelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.showStarterLoader
);

export const goAppModalVisibilitySelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.showGoAppModal
);

export const sidebarVisibilitySelector = createSelector(
  layoutStateSelector,
  (layoutState) => layoutState.showSidebar
);